export enum THRESHOLD {
  DEFAULT = 'DEFAULT',
  DANGER = 'DANGER',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

export enum VALUE_TYPE {
  CURRENCY = 'CURRENCY',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum KPI {
  VALID_ORDERS = 'validOrders',
  ORDER_RATING = 'orderRating',
  DELIVERY_ORDER_AGGROUPMENT = 'deliveryOrderAggroupmentRate3More',
  AVAILABILITY_RATE = 'availabilityRate',
  FILL_RATE = 'fillRate',
  IDEAL_PORTFOLIO_RATE = 'idealPortfolioRate',
  DELIVERY_TRACKING_ACCURACY_RATE = 'deliveryTrackingAccuracyRate',
  TEN_MINUTES_DELIVERY_RELEASE_RATE = 'tenMinutesDeliveryReleaseRate',
  FIVE_MINUTES_DELIVERY_RELEASE_RATE = 'fiveMinutesDeliveryReleaseRate',
  THIRTY_FIVE_MINUTES_DELIVERY_ACCURATE_RATE = 'thirtyFiveMinutesDeliveryAccurateRate',
  FIFTEEN_MINUTES_DELIVERY_ACCURATE_RATE = 'fifteenMinutesDeliveryAccurateRate',
  PROMO_SELLER_ACTIVATION_RATE = 'promoSellerActivationRate',
}

export enum KPI_TABS {
  GENERAL = 'general',
  TURBO = 'turbo',
}

export const KPI_REPORT: Record<KPI_TABS, KPI[]> = {
  [KPI_TABS.GENERAL]: [
    KPI.VALID_ORDERS,
    KPI.ORDER_RATING,
    KPI.PROMO_SELLER_ACTIVATION_RATE,
    KPI.DELIVERY_ORDER_AGGROUPMENT,
    KPI.AVAILABILITY_RATE,
    KPI.FILL_RATE,
    KPI.IDEAL_PORTFOLIO_RATE,
    KPI.DELIVERY_TRACKING_ACCURACY_RATE,
    KPI.TEN_MINUTES_DELIVERY_RELEASE_RATE,
    KPI.THIRTY_FIVE_MINUTES_DELIVERY_ACCURATE_RATE,
  ],
  [KPI_TABS.TURBO]: [
    KPI.VALID_ORDERS,
    KPI.ORDER_RATING,
    KPI.FILL_RATE,
    KPI.DELIVERY_TRACKING_ACCURACY_RATE,
    KPI.FIVE_MINUTES_DELIVERY_RELEASE_RATE,
    KPI.FIFTEEN_MINUTES_DELIVERY_ACCURATE_RATE,
  ],
}
